export default "__VITE_ASSET__CHGydGcX__"